<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementIndex from './settlement/index.vue'
	import wechaty from '@/views/main/wechaty/index.vue'
	import boxrule from '@/views/main/supplier/boxrule/index.vue'
	import log from './log/index.vue'
	import score from './score/index.vue'
	import footerIndex from './footer/index.vue'
	export default {
		extends: listBase,
		name: 'supplierIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'supplier',
				windowName: '供应商',
				//windowType: 'window',
				exportData: [],
				loading: false,
				settlementTitle: '自动结算',
				messageTitle: '自动结算',
				currentrow: null,
				boxruleShow: false,
				currentRow:{},
				supplierscoreShow:false
			}
		},
		render(h) {
			this.$slots.footer = [
				<footer-index currentRow={this.currentRow} ref="supplierFooter" />
			]
			this.$slots.plug = [ 
				<settlement-index row = {this.currentRow} title = {this.settlementTitle} ref = "settlementIndex" /> , 
				<wechaty row = {this.currentrow} title = {this.messageTitle} ref = "wechatyIndex" />,
				<vxe-modal v-model={this.boxruleShow} title="盒/箱规设置" width="1000" height="600" destroy-on-close>
					<template slot="default">
						<boxrule onSubmit={this.boxconfigSubmit} />
					</template>
				</vxe-modal>,
				<log currentrow = {this.currentrow} ref = "supplierlog" />,
				<vxe-modal v-model={this.supplierscoreShow} title="供应商积分" width="1200" height="600" destroy-on-close>
					<template slot="default">
						<score supplier = {this.currentrow} ref = "supplierscore" />
					</template>
				</vxe-modal>,

			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			cellClick({row}){
				this.currentRow = row
			},
			upload(item) {
				this.$api.flow.getSingleFlowTemplate(33).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'supplierupload',
								id: 0,
								controlltype: 1,
								windowName: '供应商同步万里牛',
								extra: JSON.stringify({
									uploadsupplierid: item.id,
									suppliername: item.name,
									suppliercode: item.code,
									type: item.type,
									maingoodstype: item.maingoodstype,
									isnonstandard: item.isnonstandard,
									phone: item.phone,
									havetax: item.havetax,
									paymentmethod: item.paymentmethod,
									paymentlevel: item.paymentlevel
								}),
								isflow: 1,
								flowid: 33
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, item.formname + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(item.formname + 'form open')
							}
						}

					}
				})
			},

			score(row) {
				this.currentrow = row
				this.supplierscoreShow = true
			},
			synchronousjindie() {
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				let ids = data.map((item)=>{
					return item.id
				})
				this.loading = true
				this.$api[this.moduleName].synchronousjindie({ids:ids}).then(() => {
					this.loading = false
					this.$message.success('操作成功')
				}, () => {
					this.loading = false
				})

			},
			boxrule(row) {
				this.currentrow = row
				this.$refs.supplierlog.modal_show()
			},
			boxconfig() {
				this.boxruleShow = true
			},
			boxconfigSubmit() {
				this.boxruleShow = false
			},
			getBestPurchase(total = 1600, binQty = 1000, boxQty = 0, upgradethreshold = 0.8, errorthreshold = 0.2) {
				let binres = null
				let boxres = null
				let obj = {}
				if (binQty && boxQty) {
					binres = this.getBestUnitNum(total, binQty, upgradethreshold)
					if (binres.remain) {
						boxres = this.getBestUnitNum(binres.remain, boxQty, upgradethreshold)
						obj = {
							bin: binres.requirenum,
							box: boxres.requirenum,
							total: binres.total + boxres.total,
							remain: boxres.remain,
						}
					} else {
						obj = {
							bin: binres.requirenum,
							box: 0,
							total: binres.total,
							remain: binres.remain
						}
					}
				} else if (binQty) {
					binres = this.getBestUnitNum(total, binQty, upgradethreshold)
					obj = {
						bin: binres.requirenum,
						box: 0,
						total: binres.total,
						remain: binres.remain
					}
				} else if (boxQty) {
					boxres = this.getBestUnitNum(total, boxQty, upgradethreshold)
					obj = {
						bin: 0,
						box: boxres.requirenum,
						total: boxres.total,
						remain: boxres.remain
					}
				} else {
					obj = {
						bin: 0,
						box: 0,
						total: total,
						remain: 0
					}
				}
				obj.diff = total - obj.total
				if (obj.bin && binQty * errorthreshold < obj.remain) {
					obj.error = '剩余数量大于箱规20%'
				}
				if (obj.box && boxQty * errorthreshold < obj.remain) {
					obj.error = '剩余数量大于盒规20%'
				}
				return obj

			},
			getBestUnitNum(total, unitnum, threshold) {
				let requirenum = Math.floor(total / unitnum);
				let remain = total - requirenum * unitnum;
				if (remain >= threshold * unitnum) {
					requirenum += 1;
					remain = 0;
				}
				return {
					requirenum: requirenum,
					total: requirenum * unitnum,
					remain: remain
				};
			},




			pull(row, isbatch = false) {

				//let res = this.getBestPurchase()
				//console.log(res)
				this.loading = true
				return new Promise((reslove) => {
					this.$api[this.moduleName].pull({
						code: row.code
					}).then(() => {
						this.loading = false
						if (!isbatch) {
							this.customreload()
						}
						reslove()
					}, () => {
						this.loading = false
						reslove()
					})
				})
			},
			autopullorders() {
				let data = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if (data.length == 0) {
					this.$message.error('请选择数据')
					return
				}
				let promise = []
				data.forEach((item) => {
					promise.push(this.pull(item, true))
				})
				Promise.all(promise).then(() => {
					this.customreload()
				})

			},
			settlement() {
				this.$refs.settlementIndex.modalShow()
			},
			message(row) {
				if (row.wxroom) {
					this.messageTitle = '供应商：' + row.name
					this.currentrow = row
					this.$refs.wechatyIndex.modalShow()
				} else {
					this.$message.error('未绑定微信群ID')
				}
			}
		},
		components: {
			settlementIndex,
			boxrule,
			log,
			score,
			footerIndex
		}
	}
</script>